import React, { useContext } from 'react';
import RecorderDrawerContext from '../../Context';
import { MessageTemplatePanel } from './MessageTemplatePanel';
import {
  AnimatedDiv,
  HideAnimation,
  ShowAnimation,
} from '@vimily/bonjoro-ui-components-v2/AnimatedDiv';
import { MessagePanel } from './MessagePanel';
import { ThumbnailPickerPanel } from './ThumbnailPickerPanel';
import cx from 'classnames';

const sidebarPanelClassName =
  'w-full flex flex-col p-4 md:items-baseline gap-y-6';

export function Sidebar() {
  const { topSidebarComponent } = useContext(RecorderDrawerContext);

  return (
    <div className='v2-bg-neutral-50 h-full w-full md:w-[45%] md:overflow-y-auto'>
      {topSidebarComponent && (
        <AnimatedDiv
          className={cx(sidebarPanelClassName, 'w-full h-auto overflow-auto')}
          showAnimation={ShowAnimation.SlideInDown150}
          hideAnimation={HideAnimation.SlideOutUp150}
          show
        >
          {topSidebarComponent}
        </AnimatedDiv>
      )}
      <span className='block w-full h-[1px] v2-bg-neutral-300' />
      <div className={sidebarPanelClassName}>
        <MessageTemplatePanel />
        <MessagePanel />
        <ThumbnailPickerPanel />
      </div>
    </div>
  );
}
